import React from 'react'

import './globalStaffingSnapshot.css'

export const GlobalStaffingSnapshot = ({location}) => {
    let usaLists = location.filter(type => type.locationType === 'USA')
    let internationalLists = location.filter(type => type.locationType === 'International')
    return (
        <div className="global-staffing-snapshot">
            <div className="grid col-2 col-1-lg gap-15">
                <div className="flex justify-center align-center pr-40 pl-40 text-center">
                    <h3>Savor Brands<br/><span>Where's Paul?</span></h3>
                    <img src='https://images.ctfassets.net/vhts96p7twn6/2UQLhWchzJcBQRELxCYyQP/838e3277e00765f27cdcd7bf641f8605/paul.png' className="mb-0" alt="Paul Read" />
                </div>
                <div></div>
            </div>
            <div className="grid col-2 col-1-lg gap-15">
                <div className="pl-40 pr-40 text-center map">
                    <img src='https://images.ctfassets.net/vhts96p7twn6/5GcEtUJoUru8hzRnBa48vG/70284d8461891596ac535d06f85b5fdb/map-red.png' alt='Map'/>
                </div>
                <div className="pr-40 pl-40 global">
                    <div className="grid col-2 col-1-lg gap-15">
                        <div className="brand-color">
                            <h4 className="mt-0 mb-10"><span>United States:</span></h4>
                            <div className="grid-col-3">
                                {usaLists.map((item, index) => (
                                    <div key={index}>
                                        {item.link !== null ? (
                                            <a href={`/${item.subdirectory}${item.link}`} className="block link bold">{item.name}</a>
                                        ):(
                                            <div className="link bold">{item.name}</div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="red">
                            <h4 className="mt-0 mb-10"><span>International:</span></h4>
                            <div className="grid-col-2">
                                {internationalLists.map((item, index) => (
                                    <div key={index}>
                                        {item.link !== null ? (
                                            <a href={`/${item.subdirectory}${item.link}`} className="link bold">{item.name}</a>
                                        ):(
                                            <div className="link bold">{item.name}</div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}